import React, { useRef, useState, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import * as THREE from 'three';
import { OrbitControls } from '@react-three/drei';

function HorizontalGrid({ size = 20, divisions = 10 }) {
  return (
    <>
      {/* X-Z plane grid */}
      <gridHelper args={[size, divisions, '#fffff', '#fffff']} />
    </>
  );
}

export function Scene({ modelData, modelType = 'obj', modelURL='' }) {
  const objRef = useRef();
  const [loadedModel, setLoadedModel] = useState(null);

  useFrame(() => {
    if (objRef.current) {
      objRef.current.rotation.y += 0.01; // Rotate dynamically
    }
  });

  // Load the model dynamically based on modelType (either 'obj' or 'glb')
  useEffect(() => {
    if (modelURL && objRef.current) {
      console.log(modelData)
      console.log('Model Data consoled')
      let loader;
      let parsedModel;

      // Decide which loader to use based on modelType
      if (modelType === 'obj') {
        loader = new OBJLoader();
        parsedModel = loader.parse(modelData);
      } else if (modelType === 'glb') {
        loader = new GLTFLoader();
        loader.load(
          modelURL,
          (gltf) => {
            console.log(gltf)
            console.log('gltf consoled')
            parsedModel = gltf.scene;
            console.log(parsedModel)
            console.log('parsed model logged')
            setLoadedModel(parsedModel);
          },
          undefined,
          (error) => console.error('Error loading GLB model', error)
        );
        return;
      }

      // If the OBJ model is loaded directly, process and add to scene
      if (parsedModel) {
        // Clear any existing models
        while (objRef.current.children.length > 0) {
          objRef.current.remove(objRef.current.children[0]);
        }

        // Compute bounding box of the model
        const boundingBox = new THREE.Box3().setFromObject(parsedModel);
        const size = new THREE.Vector3();
        boundingBox.getSize(size);

        // Compute scale factor for a desired size
        const targetSize = 50; // Desired size for the model
        const maxDimension = Math.max(size.x, size.y, size.z);
        const scaleFactor = targetSize / maxDimension;

        // Apply scaling to the model
        parsedModel.scale.set(scaleFactor, scaleFactor, scaleFactor);

        // Compute the center of the bounding box
        const center = new THREE.Vector3();
        boundingBox.getCenter(center);

        // Subtract center to make sure the model is centered around (0, 0, 0)
        parsedModel.position.sub(center);

        // Set position
        parsedModel.position.y = 0; // Align model to the grid at y = 0 (same level as your box)
        parsedModel.position.x = 0;
        parsedModel.position.z = 0;

        // Add the model to the scene
        objRef.current.add(parsedModel);
      }
    }
  }, [modelData, modelType,modelURL]);

  return (
    <>
      {/* Lights */}
      <ambientLight intensity={0.1} />
      <directionalLight color="white" intensity={0.2} position={[0, 0, 5]} />

      {/* Horizontal Grid */}
      <HorizontalGrid size={50} divisions={20} />

      {/* OrbitControls for zoom and pan */}
      <OrbitControls enableZoom enablePan />

      {/* Dynamic Model */}
      <group ref={objRef} />
    </>
  );
}
